import { AppConfig } from '../types';

export const appConfig: AppConfig = {
  title: 'Mental Health Development',
  sections: [
    { id: 'header', component: 'Header', enabled: true },
    { id: 'hero', component: 'Hero', enabled: true },
    { id: 'about', component: 'About', enabled: true },
    { id: 'services', component: 'Services', enabled: true },
    { id: 'team', component: 'Team', enabled: true },
    { id: 'experts', component: 'Experts', enabled: true },
    { id: 'timeline', component: 'Timeline', enabled: true },
    { id: 'testimonials', component: 'Testimonials', enabled: true },
    { id: 'contact', component: 'Contact', enabled: true },
    { id: 'footer', component: 'Footer', enabled: true },
    { id: 'vision', component: 'Vision', enabled: false },
    { id: 'faq', component: 'FAQ', enabled: false },
  ],
};
